import { BM20_ID } from '../tenants/BusinessModelMgr';
const isProductAvailableBm20 = (assortmentRules, product, shopId) => {
    var _a;
    const isCoreProduct = Boolean((_a = product.options) === null || _a === void 0 ? void 0 : _a.isCoreProduct);
    if (isCoreProduct)
        return true;
    if (!shopId)
        return false;
    return assortmentRules.some((rule) => rule.productId === product.id);
};
const isProductAvailableDefault = (assortmentRules, product) => {
    return !assortmentRules.some((rule) => rule.productId === product.id);
};
const AssortmentRulesDomain = {
    isProductAvailable: (props) => {
        const { product, bmId, shopId } = props;
        const assortmentRules = props.assortmentRules.filter((x) => x.shopId === shopId);
        if (bmId === BM20_ID) {
            return isProductAvailableBm20(assortmentRules, product, shopId);
        }
        return isProductAvailableDefault(assortmentRules, product);
    },
};
export default Object.freeze(AssortmentRulesDomain);
